import { useEffect, useRef } from "react";
import rightarrow from "../../images/cashbach/arrow-right-s-line1.svg";
import Unibankheartfill from "../../images/cashbach/Unibank-heart-fill.svg";
import shareicon from "../../images/cashbach/share-icon.svg";
import { RestuarantDetailstyles } from "./RestuarentDetail.styled";
import { Carousel } from "antd";
import web from "../../images/cashbach/global-line.svg";
import facebook from "../../images/cashbach/facebook-fill.svg";
import instagram from "../../images/cashbach/instagram-line.svg";
import locationicon from "../../images/cashbach/map-pin-fill.svg";
import directionicon from "../../images/cashbach/direction-fill.svg";
import leftarrow1 from "../../images/cashbach/arrow-left-s-line-1.svg";
import rightarrow1 from "../../images/cashbach/arrow-left-s-line-1.svg";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllmerchantsAPI, getAllOffersAPI } from "../../redux/slices/reports/reportsService";
import { checkIsMobile } from "../../Utills/Utill";

const RestuarantDetailpage = () => {

  const dispatch = useDispatch();

  const { allMerchantsList, allOffersList } = useSelector(
    (state: any) => state?.reports
  );

  useEffect(() => {
    dispatch(getAllmerchantsAPI({ id: "68da53018d46074c47d36613" }));
    dispatch(getAllOffersAPI({ id: "68da53018d46074c47d36613" }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
const { id : offerId}: any = useParams();

  const offerData = allOffersList?.data?.find((item: any) => item?._id === offerId);
  const merchantData = allMerchantsList?.data?.find((item: any) => item?._id === offerData?.merchantId);
  
  const carouselRef = useRef<any>(null);

  const handleNext = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
    }
  };

  const handlePrev = () => {
    if (carouselRef.current) {
      carouselRef.current.prev();
    }
  };

  const handleFacebookRedirect = () => {
    if(merchantData?.facebook) {
      window.location.href = merchantData?.facebook;
    }
  };

  const handleInstagramRedirect = () => {
    if(merchantData?.instagram) {
      window.location.href = merchantData?.instagram;
    }
  };

  const handleWebRedirect = () => {
    if(merchantData?.website) {
      window.location.href = merchantData?.website;
    }
  };
  const history = useHistory();

  return (
    <RestuarantDetailstyles>
      <div className="detail-page-section">
        <div className="breadcrumbs-section">
          <img
            src={rightarrow}
            alt="rightarrow"
            onClick={() => {
              history.goBack()
            }}
          />
          Atrás
        </div>
        <div className="home-container carousel-wrapper detailpage-bannerimg">
          <Carousel
            autoplay
            autoplaySpeed={2000}
            infinite
            speed={500}
            ref={carouselRef}
            dots
            dotPosition="bottom"
            className="banner_img_carsousel"
          >
            {offerData?.offerImages?.map((item: any, idx: number) => (
              <div className="carouse_image_wrapper" key={`car_ousel_${idx}`}>
                <img src={item} alt="banner1" className="h-100" />
            {!checkIsMobile() && (
              <>
                <button
                  onClick={handlePrev}
                  className="carousel-arrow left-arrow"
                >
                  <img src={leftarrow1} alt="left arrow" />
                </button>
                <button
                  onClick={handleNext}
                  className="carousel-arrow right-arrow"
                >
                  <img src={rightarrow1} alt="right arrow" />
                </button>
                </>
            )}
              </div>
            ))}
          </Carousel>
          <div className="banner-logo">
            <img src={merchantData?.merchantImageUrl} alt="logo" />
          </div>
        </div>
        <div className="banner-like-share-section">
          <h5>{merchantData?.merchantName}</h5>
          <div className="banner-like-share-section-btns">
            <div onClick={
              handleFacebookRedirect
            }>
              <img src={facebook} alt="facebook" />
            </div>
            <div onClick={
              handleInstagramRedirect
            }>
              <img src={instagram} alt="insta" />
            </div>
            <div 
            onClick={
              handleWebRedirect
            }
            >
              <img src={web} alt="web" />
            </div>
            <div>
              <img src={Unibankheartfill} alt="hearticon" />
            </div>
            <div>
              <img src={shareicon} alt="shareicon" />
            </div>
          </div>
        </div>
        <div className="location row">
          <div className="col-6 d-flex location-section">
            <img src={locationicon} alt="locationicon" />
            <p>
            {merchantData?.addressline1},
            {merchantData?.addressline2} {} 
            {merchantData?.addressline2 && ","}
            {merchantData?.city}  
            {merchantData?.city && ","}
            {merchantData?.state}  
            {merchantData?.state && ","}
            {merchantData?.zipcode}  
            {merchantData?.zipcode && ","}
            {merchantData?.country}  
            </p>
          </div>
          <div className="col-6 button-section">
            <button>
            OBTENER DIRECCIONES
              <img src={directionicon} alt="locationicon" />
            </button>
          </div>
        </div>
        <div className="detailpage-bannerimg-text">
          <h5>
            {offerData?.offerName}
          </h5>
          <p>
          {offerData?.offerDiscription}
          </p>
          <p>
            Haz clic aquí para ver los 
            <span
            onClick={() => history.push('/termsandconditions')}
            style={{ cursor: 'pointer' }}
            >
              Términos y Condiciones.
            </span>
          </p>
        </div>
      </div>
    </RestuarantDetailstyles>
  );
};

export default RestuarantDetailpage;
